import { TreeDataItem } from '@/components/treeview-dropdown';

// Build path to show ancestors in placeholder
const buildItemPath = (targetItem: string, data: TreeDataItem[]): string[] => {
  const path: string[] = [];

  const findPath = (
    items: TreeDataItem[],
    target: string,
    currentPath: string[] = []
  ): boolean => {
    for (const item of items) {
      const newPath = [...currentPath, item.name];

      if (item.id === target) {
        path.push(...newPath);
        return true;
      }

      if (item.children && findPath(item.children, target, newPath)) {
        return true;
      }
    }
    return false;
  };

  findPath(data, targetItem);
  return path;
};

export const getPlaceholderText = (
  selectedItem: string | null,
  data: TreeDataItem[],
  placeholder?: string
) => {
  if (!selectedItem) return placeholder;

  const path = buildItemPath(selectedItem, data);
  if (path.length <= 2) {
    return path.join(' > ');
  }
  // Show up to 2 ancestors: "ancestor1 > ancestor2 > selected"
  return path.slice(-3).join(' > ');
};